import React from "react";

const SummerAnimation = () => {
  return <div></div>;
};

export default SummerAnimation;
